import { useEffect } from 'react';

/**
 * `single-customer-app` in index.css differentiates MSR3 theme tokens from the
 * legacy SR.app UI. Applying it to `document.body` while an MSR3 layout is
 * mounted lets portaled overlays (dialogs, dropdowns, comboboxes, toasts) —
 * which render outside the layout's DOM subtree — inherit those tokens, and
 * removes it on unmount so legacy routes are unaffected.
 *
 * Not needed after the MSR3 launch, when the class comes out of index.css.
 */
export const MSR3_BODY_CLASS = 'single-customer-app';

export const useMsr3ThemeBody = () => {
  useEffect(() => {
    document.body.classList.add(MSR3_BODY_CLASS);

    return () => {
      document.body.classList.remove(MSR3_BODY_CLASS);
    };
  }, []);
};
